import React from 'react'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Button from '@mui/material/Button'
import InputAdornment from '@mui/material/InputAdornment'
import SearchIcon from '@mui/icons-material/Search'
import DateRangeSelector from './DateRangeSelector'
import { FilterCard, FilterRow, StyledTextField } from '../styles'
import {
  PAYMENT_METHODS,
  PAYMENT_STATUSES,
  METHOD_LABELS,
  PAYMENT_STATUS_LABELS,
} from '../constants'

// `onChange` receives a patch of the fields that changed, never the whole
// filter object — consecutive calls within one event must not clobber each
// other. See handleFiltersChange in the container.
const BillingFilters = ({ filters, onChange, onClear }) => {
  const setField = field => value => onChange({ [field]: value })

  return (
    <FilterCard>
      <FilterRow>
        <DateRangeSelector
          startDate={filters.startDate}
          endDate={filters.endDate}
          onStartDateChange={setField('startDate')}
          onEndDateChange={setField('endDate')}
        />
      </FilterRow>
      <FilterRow>
        <StyledTextField
          select
          size="small"
          label="Method"
          value={filters.method}
          onChange={e => setField('method')(e.target.value)}
          sx={{ minWidth: 140 }}
        >
          <MenuItem value="">All</MenuItem>
          {PAYMENT_METHODS.map(m => (
            <MenuItem key={m} value={m}>
              {METHOD_LABELS[m]}
            </MenuItem>
          ))}
        </StyledTextField>

        <StyledTextField
          select
          size="small"
          label="Payment status"
          value={filters.paymentStatus}
          onChange={e => setField('paymentStatus')(e.target.value)}
          sx={{ minWidth: 180 }}
        >
          <MenuItem value="">All</MenuItem>
          {PAYMENT_STATUSES.map(s => (
            <MenuItem key={s} value={s}>
              {PAYMENT_STATUS_LABELS[s]}
            </MenuItem>
          ))}
        </StyledTextField>

        <StyledTextField
          size="small"
          label="Search patient or contract"
          value={filters.search}
          onChange={e => setField('search')(e.target.value)}
          sx={{ minWidth: 240, flex: 1 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        <Box sx={{ marginLeft: 'auto' }}>
          <Button
            variant="text"
            onClick={onClear}
            sx={{ textTransform: 'none' }}
          >
            Clear
          </Button>
        </Box>
      </FilterRow>
    </FilterCard>
  )
}

export default BillingFilters
